var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',[_c('el-breadcrumb',{attrs:{"slot":"header"},slot:"header"},[_c('el-breadcrumb-item',{attrs:{"to":{name: 'news/drafts'}}},[_vm._v("Drafts")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.article.header))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd6793d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/news/Edit.vue
// module id = null
// module chunks = 